import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles.css'
import './lite2.css'
import './lite3.css'
import './lite4.css'
import './lite5.css'
import './visual-refresh.css'
import './lite67.css'
import './interaction-polish.css'
import './review-settings.css'
import './event-export-polish.css'
import './selection-known-events.css'
import './large-library-polish.css'
import './smart-categories.css'
import './view-sidebar.css'
import './global-processes.css'
import './folder-drop.css'
import './lite/performance.css'
import './theme.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
